import React, { FC } from 'react';

import { HStack } from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';

import { FilterLabelWrapper } from 'components/DataDisplay/Box/BorderedBox/FilterLabelWrapper';
import { ButtonGroup } from 'components/DataEntry';
import { alertsGroupedByOptions } from 'containers/Findings/Alerts/Components/AlertsTable/utils';
import { selectAlerts } from 'containers/Findings/Alerts/selectors';
import { actions } from 'containers/Findings/Alerts/slice';

export const ViewIssuesBy: FC = () => {
  const dispatch = useDispatch();
  const { groupByResource } = useSelector(selectAlerts);

  return (
    <HStack>
      <FilterLabelWrapper>VIEW BY</FilterLabelWrapper>
      <ButtonGroup
        items={alertsGroupedByOptions}
        value={
          groupByResource
            ? alertsGroupedByOptions[1]
            : alertsGroupedByOptions[0]
        }
        onClick={s => dispatch(actions.updateGroupByResource(s?.value))}
      />
    </HStack>
  );
};
